import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
    PullRefresh,
    List,
    Swipe,
    SwipeItem,
    NavBar
} from 'vant';
import 'vant/lib/index.css';
import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'
import VueI18n from 'vue-i18n';
import animated from 'animate.css'
import svga from 'vue-svga'
import Time from './components/module/time.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Tabbar from "@/components/module/Tabbar.vue";
Vue.component('Tabbar', Tabbar)
import HEADER from "@/components/module/header.vue";
Vue.component('HEADER', HEADER)
import HeaderReturn from "@/components/module/HeaderReturn.vue";
import Test from '@/views/pages/test.vue';
Vue.component('Test', Test)
import Tests from '@/views/pages/tests.vue';
Vue.component('Tests', Tests)

import Txt from '@/views/pages/txt.vue';
Vue.component('Txt', Txt)
Vue.component('HeaderReturn', HeaderReturn)
Vue.use(ElementUI);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
Vue.use(Time)
Vue.use(svga);
Vue.use(animated);
Vue.use(VueClipboard)
Vue.use(VueCookies)
Vue.use(PullRefresh);
Vue.use(NavBar);
Vue.use(VueI18n);
Vue.config.productionTip = false


var moment = require('moment');
Vue.filter('timeFormat', function (tick) {
    return moment(tick).format("HH:mm:ss");
});
Vue.filter('dateFormat', function (tick) {
    return moment(tick).format("YYYY-MM-DD HH:mm:ss");
});
Vue.filter('YsFormat', function (tick) {
    return moment(tick).format("MM-DD HH:mm:ss");
});
//移动端调试
// import Vconsole from 'vconsole'

// let vConsole = new Vconsole()
// export default vConsole

const i18n = new VueI18n({
    locale: 'zh_CN', // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh_CN': require('./common/lang/zh'),
        'zh_TW': require('./common/lang/tw'),
        'en_US': require('./common/lang/en'),
        // 'ja_JP': require('./common/lang/ja'),
        // 'ko_KR': require('./common/lang/ko'),
        // 'be_BY': require('./common/lang/be'),
        // 'th_TH': require('./common/lang/th'),
    }
});

// 这里就可以进行vue-router的beforeEach拦截了，你也可以放其他地方，我比较喜欢放这
router.beforeEach((to, from, next) => {
   
    // 这里先获取下用户信息，我偷懒用sessionStorage存了
    // 里面包含了用户权限，用户各种信息等
    const user = JSON.parse(localStorage.getItem('MEMBER'));
    // 这里必须加上to.path !== 'login'的判断，不然会陷入无限循环，
    // 因为逻辑是第一次进来，判断用户信息不存在，即!user为true，由于使用的是next('/login')而非next()，
    // 会再次进入路由跳转，next()方法没有参数是直接进入页面，不会再次进入路由拦截，有参数则会，因为跳转，
    // 所以再次进入路由，再次判断，再次进入路由，再次判断，循环往复无限循环
    // 所以一定要加to.path !== 'login'的判断
    if (!user && to.path !== '/member/login' && to.path !== '/member/register' && to.path !== '/member/Retrieve') {
        next('/member/login');
    } else {
        next();
    }
});



const mainVue = new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')